export enum PaymentGateway {
  STRIPE = 'STRIPE',
  REDSYS = 'REDSYS',
}
